function createRefreshCoordinator(refresh) {
  let inFlight = null;
  return () => {
    if (!inFlight) inFlight = Promise.resolve().then(refresh).finally(() => { inFlight = null; });
    return inFlight;
  };
}
module.exports = { createRefreshCoordinator };
